<template>
    <TransloadAndDeliverTimeline :back="{ name: 'IncidentProcessTransload' }"/>
  </template>
  
  <script>
  import TransloadAndDeliverTimeline from "@/components/3pl/IncidentAndRequest/Transload/TransloadAndDeliverTimeline";
  export default {
    components: { 
        TransloadAndDeliverTimeline,
    },
  };
  </script>
  
  <style>
  </style>